const ADDRESS_FIELDS = ["street", "house_number", "zip", "city", "country"];

export function normalizedCustomerAddress(address) {
  return Object.fromEntries(ADDRESS_FIELDS.map(key => [key, (address?.[key] || "").trim().replace(/\s+/g, " ")]));
}

export function validateCustomerAddress(address) {
  if (ADDRESS_FIELDS.some(key => !(address?.[key] || "").trim())) {
    return "Completa via, numero civico, CAP, località e paese.";
  }
  if (ADDRESS_FIELDS.some(key => /[\x00-\x1f\x7f]/.test(address[key]))) {
    return "Inserisci un indirizzo valido, senza caratteri di controllo.";
  }
  const cleaned = normalizedCustomerAddress(address);
  const country = cleaned.country.toLowerCase();
  if (["ch", "svizzera", "switzerland", "schweiz", "suisse", "svizra"].includes(country)) {
    if (!/^\d{4}$/.test(cleaned.zip)) return "Il CAP svizzero deve contenere 4 cifre.";
  } else if (["it", "italia", "italy", "italien", "italie"].includes(country)) {
    if (!/^\d{5}$/.test(cleaned.zip)) return "Il CAP italiano deve contenere 5 cifre.";
  } else if (!/^[A-Za-z0-9][A-Za-z0-9 -]{0,19}$/.test(cleaned.zip)) {
    return "Inserisci un codice postale valido.";
  }
  return null;
}

export function formatCustomerAddress(address) {
  const text = key => typeof address?.[key] === "string" ? address[key].trim() : "";
  return [[text("street"), text("house_number")].filter(Boolean).join(" "),
    [text("zip"), text("city")].filter(Boolean).join(" "), text("country")]
    .filter(Boolean).join(", ") || "Non indicato";
}
